export enum FocusElementEnum {
  first = 'first',
  last = 'last'
}
